var digistorm = {

    init: function () {

        // helper for iOS issues
        this.iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

        // load nav
        this.nav();


        // load tabs
        this.tabs();
        this.accordions();

        // load videos
        this.videos.init();

        // load carousel
        this.slick();


        // load calendars
        this.calendars();
        this.events();

        this.forms();
        this.social();

        this.popups();
        this.analytics();

        this.employment();

        this.newsletters();

        this.entryCalculator();
    },

    nav: function () {
        // find any navbar burger buttons
        $('.navigation').find('.navbar-burger').click(function (e) {
            e.preventDefault();

            // find specified navbar
            target = $(this).attr('data-target')

            if (target.length) {
                // toggle active class on burger button
                $(this).toggleClass('is-active');

                // toggle active class on specified menu
                $('#' + target).toggleClass('is-active');
            }
        });

        // find any navbar search buttons
        $('.navigation').find('.search-button').click(function (e) {
            e.preventDefault();

            // find specified navbar
            target = $(this).attr('data-target')

            if (target.length) {
                // toggle active class on specified element
                $('#' + target).toggleClass('is-active');

                if ($('#' + target).is('.is-active')) {
                    $('input.search').focus();
                } else {
                    $('input.search').blur();
                }
            }
        });

    },

    videos: {

        init: function() {

            var _self = this;

            // check if there is a video player wrapper
            if ($('.video-player').length) {
                $('.video-player').each(function() {
                    _self.loadVideo(this)
                })
            }

            _self.controls()
            _self.carousel();
        },

        controls: function() {
            // initialise video controls

            $('.video-carousel .banner .control-pause').click(function () {
                $player = $(this).closest('.banner').find('.video-player');
                switch (digistorm.videos.togglePlay($player)) {
                    case 'no-data':
                        break;
                    case true:
                        $(this).removeClass('fa-play').addClass('fa-pause');
                        break;
                    case false:
                        $(this).removeClass('fa-pause').addClass('fa-play');
                        break;
                }
            });

            $('.video-carousel .banner .control-vol').click(function () {
                $player = $(this).closest('.banner').find('.video-player');
                switch (digistorm.videos.toggleMute($player)) {
                    case 'no-data':
                        break;
                    case true:
                        $(this).removeClass('fa-volume-off').addClass('fa-volume-up');
                        break;
                    case false:
                        $(this).removeClass('fa-volume-up').addClass('fa-volume-off');
                        break;
                }
            });
        },

        carousel: function() {
            // handle videos inside slick carousels
            $('.video-carousel').on('init', function(event, slick) {
                // mark carousel as initialized
                slick.is_initialized = true;
            }).on('setPosition', function(event, slick) {
                // synchronize slides with videos

                if (slick.is_initialized) {
                    // the slide up next
                    var $newSlide = $(slick.$slides[slick.currentSlide]);

                    // pause others
                    $newSlide.closest('.video-carousel').find('.banner').not($newSlide).find('.video-player').each(function(i, e) {
                        if (digistorm.iOS) {
                            // currently there's a bug with plyr where pause won't work on iOS
                            digistorm.videos.stopVideo($(e));
                        } else {
                            digistorm.videos.pauseVideo($(e));
                        }
                    });

                    // play new slide
                    var video = $newSlide.find('.video-player');
                    digistorm.videos.playVideo(video);
                    if (video.data() && video.data().player) {
                        // This slide is a video, pause slick autoslide
                        slick.$slider.slick('slickPause');
                    } else {
                        // This slide is not a video, resume slick autoslide
                        slick.$slider.slick('slickPlay');
                        $(".circleProgress").css('animation-duration', 5.9 + 's');
                    }
                }
            });
        },

        loadVideo: function(el) {
            // load a video element

            // get each config attr from this element
            var settings = JSON.parse($(el).attr('data-settings'))

            // grab player elements
            var player = $(el).find('.player')

            var plyr = new Plyr(player[0], settings)
            // set up each video
            $(el).data({
                player: plyr
            });

            // if a carousel video, go to the next slide on video end
            var $carousel = $(el).closest('.video-carousel');
            if ($carousel.length) {

                if (((plyr.provider && plyr.provider.indexOf('youtube') >= 0) || (plyr.source && plyr.source.indexOf('youtube') >= 0))) {
                    // youtube loop doesn't work, manually detect end of video
                    plyr.on('timeupdate', function(event) {
                        if (plyr.currentTime >= plyr.duration - 0.1) {
                            plyr.restart();
                            if ($carousel.find('.banner').length > 1) {
                                $carousel.slick('slickNext');
                            }
                        }
                    });
                } else {
                    // on loop, go to the next slide
                    plyr.on('seeked', function (event) {
                        if ($(event.target).closest('.slick-slide').hasClass('slick-active')
                        && Date.now() > digistorm.videos.lastseeked + 1000) {
                            $carousel.slick('slickNext');
                        }
                      });
                }

                plyr.on('playing', function() {
                    $(el).closest('.banner').find('.control-pause').removeClass('fa-play').addClass('fa-pause');
                });
                plyr.on('pause', function() {
                    $(el).closest('.banner').find('.control-pause').removeClass('fa-play').addClass('fa-pause');
                });
            }

            if (settings.muted && settings.autoplay) {
                digistorm.videos.attemptPlay(plyr);
            }
        },

        attemptPlay: function(player, count) {
            // attempts to play the video multiple times in case element is still loading

            if (!Number.isInteger(count)) {
                count = 0;
            }

            player.volume = 0;
            player.muted = true;
            player.play();
            if (count < 15) {
                setTimeout(function() {
                    if (!player.playing) {
                        count++;
                        digistorm.videos.attemptPlay(player, count);
                    }
                }, 1000);
            }
        },

        playVideo: function($el) {
            if ($el.data() && $el.data().player) {
                $el.data().player.play()
            }

        },
        pauseVideo: function($el) {
            if ($el.data() && $el.data().player) {
                $el.data().player.pause()
            }
        },
        stopVideo: function($el) {
            if ($el.data() && $el.data().player) {
                $el.data().player.stop()
            }
        },
        togglePlay: function($el) {
            if ($el.data() && $el.data().player) {
                $el.data().player.togglePlay()
                return $el.data().player.playing;
            }
            return 'no-data';
        },
        toggleMute: function($el) {
            if ($el.data() && $el.data().player) {
                player = $el.data().player;
                if (player.volume == 0) {
                    player.volume = 1;
                    return true;
                } else {
                    player.volume = 0;
                    return false;
                }
            }
            return 'no-data';
        }
    },

    slick: function () {

        // initialise banners
        $('.banners').slick({
            arrows: false,
            autoplaySpeed: 5000,
            dots: true
        })


        // load basic slick on all basic slicks
        //$('.gallery.is-basic').find('.slick').slick()
        $('.gallery.is-basic').find('.slick').slickLightbox({
            src: 'src',
            itemSelector: '.img-c div',
            caption: 'caption',
        })

        // load basic slick on all full galleries
        $('.gallery.is-full').find('.slick').slick()
        $('.profile-gallery').find('.slick').slick({
            arrows: true,
            dots: true,
        })

        // lightbox config
        $('.gallery.is-lightbox').find('ul').slickLightbox({
            itemSelector: '> li > a',
            caption: 'caption',
        })

        $('.gallery.is-lightbox .more-s').click(function (e) {
            e.preventDefault();
            $(this).closest('.is-lightbox').find('.is-hidden:first a').click();
        })
    },

    tabs: function () {
        var _self = this;

        // transform tabs into work of magic
        $('.tabs').find('.tab-title').click(function() {
            // get the relative tabs
            var $tabs = $(this).closest('.tabs')
            var activeIndex = $(this).index()

            // remove active class from all tabs
            $tabs.find('.tab-title').removeClass('is-active')
            $tabs.find('.tab-content').removeClass('is-active')

            // add active to current tab
            $(this).addClass('is-active')
            $tabs.find('.tab-content').eq(activeIndex).addClass('is-active')
        });
    },

    social: function () {

        // Populate Slider
        function populateSliders(posts) {
          $('[data-social]').each(function() {
              var index = 0;
              var limit = 3;
              var slideCount = 0;
              var monthAgo = Math.round(Date.now() / 1000) - 2592000;

              var socialClone = $('.social-template');

              posts.forEach(function(post, index){

                if (index <= 0) {
                    var block = $('.social-wrapper-second');
                } else {
                    var block = $('.social-wrapper-first');
                }

                // stop loop
                if (index >= limit) {
                    return false;
                }

                var newClone = socialClone.clone(true);
                newClone.removeClass('is-hidden');
                newClone.removeClass('social-template');

                newClone.addClass('social-' + post.channel);
                newClone.find('.data-platform').addClass('icon-' + post.channel);

                var text = (post.text);
                var len = 90;
                if (text.length > len) {
                    text = text.substring(0,len) + '...';
                }
                if(post.image.length){
                    $postImage = post.image;
                }else{
                    $postImage = "../images/logo.svg"
                }

                $image = $('<div class="image-background"></div>').css('background-image', 'url(' + $postImage + ')');

                newClone.find('.img-c').append($image);

                newClone.find('.text-c .text-p').text(text);
                if(post.channel == 'facebook'){
                    newClone.find('.img-c .fab').addClass('fa-facebook-f');
                }else{
                    newClone.find('.img-c .fab').addClass('fa-' + post.channel);
                }
                newClone.attr('href', post.link);

                newClone.data('timestamp', post.timestamp);

                var found = false;
                if(post.image.length){
                    block.find('.item-c:not(.social-template)').each(function(i,e) {
                        if (!found && parseInt(post.timestamp) > parseInt($(e).data('timestamp'))) {
                            $(e).before(newClone);
                            found = true;
                        }
                    });
                    if (!found) {
                        block.append(newClone);
                    }
                }
            });
          });
        }

        // Facebook
          $.ajax({
            url: '/api/facebook.php',
            dataType: 'json',
            success: function (facebook) {
                var posts = [];
                facebook.posts.data.forEach(function(post){
                    var postData = {};
                    postData.type = 'text';
                    postData.image = '';
                    if (post.attachments != null) {
                        var attachment = post.attachments.data[0];
                        postData.type = attachment.type;
                        if (attachment.subattachments != null) {
                            postData.image = attachment.subattachments.data[0].media.image.src;
                        } else if (attachment.media && attachment.media.image != null) {
                            postData.image = attachment.media.image.src;
                        }
                    }
                    postData.link = post.permalink_url ? post.permalink_url : post.attachments.data[0].subattachments.data[0].url;
                    postData.text = post.message ? post.message : post.story;
                    postData.comments = post.comments != null ? post.comments.data.length : 0;
                    postData.likes = post.likes != null ? post.likes.data.length : 0;
                    postData.timestamp = moment(post.created_time).format('X');
                    postData.channel = 'facebook';
                    posts.push(postData);
                });
                populateSliders(posts);
            }
          });
          //Instagram
          $.ajax({
            url: '/api/instagram.php',
            dataType: 'json',
            success: function (instagram) {
              var posts = [];
              instagram.data.forEach(function(post){
                var postData = {};
                postData.link = post.permalink;
                postData.image = post.media_url;
                postData.text = post.caption;
                postData.comments = post.comments_count;
                postData.likes = post.like_count;
                postData.type = post.type;
                postData.timestamp = post.unix_timestamp;
                postData.channel = 'instagram';
                postData.mediaType = post.media_type;
                postData.thumbnail = post.thumbnail_url ? post.thumbnail_url : 0;
                posts.push(postData);
              });
              populateSliders(posts);
              }
            });
      },

    accordions: function() {
        // accordions
        $('.tabs.style-accordion').each(function () {
            var $group = $(this);

            $('.accordion-wrapper .accordion-header', $group).click(function() {
                var $wrapper = $(this).closest('.accordion-wrapper')
                var wasActive = $wrapper.hasClass('is-active');

                // close the accordions
                $group.find('.accordion-wrapper').removeClass('is-active')
                $group.find('.accordion-content').css({ 'max-height': 0 })

                // if the accordion was active then lets just close it
                if (wasActive) {
                    return true
                }

                // get relative height needed to show the content
                var height = $wrapper.find('.tab-content').outerHeight()

                // open the accordion
                $wrapper.addClass('is-active')
                $wrapper.find('.accordion-content').css({ 'max-height': height + 'px' })
            });
        });
    },

    calendars: function () {
        var _self = this;

        $('[data-calendars]').each(function() {
            var calendarUrl = $(this).attr('data-calendar-url');
            var calendarTimezone = $(this).attr('data-calendar-timezone');

            $('.calendar-desktop').fullCalendar({
                events: function (start,end,timezone,callback) {
                    var url = calendarUrl + "&start=" + start.unix() + "&end=" + end.unix()
                    $('.calendar-desktop-loading-indicator').addClass('show');
                    $.ajax({url: url}).done(function (response){
                        $('.calendar-desktop-loading-indicator').removeClass('show');
                        callback(response)
                    });
                },
                eventDataTransform: function (e) {
                    e.start = moment.tz(parseInt(e.start_time) * 1000, calendarTimezone).format();
                    if (e.end_time != null) {
                        e.end = moment.tz(parseInt(e.end_time) * 1000, calendarTimezone).format();
                    }
                    if (e.all_day != null) {
                        e.allDay = e.all_day;
                    }
                    return e;
                },
                editable: false,
                timeFormat: 'h:mm A',
                eventClick: function (event, jsEvent, view) {

                    var $target = $(jsEvent.target)
                    var $event = $target.closest('.fc-event-container');
                    var $modal = $event.find('.cal-modal');

                    if (!$target.closest('.cal-modal').length) { // if not clicking the modal
                        if (!$modal.length) { // add the modal if it doesn't exist

                            $modal = _self.createEventModal(event, calendarTimezone);
                            $event.append($modal);

                            setTimeout(function () {
                                $modal.addClass('active')
                            }, 100);
                        } else {
                            $modal.addClass('active');
                        }
                    }
                }
            });

            $('.calendar-mobile').digistormMobileCalendar({
                url: calendarUrl,
                timezone: calendarTimezone
            });
        })
    },

    events: function () {
        var _self = this;
        $('[data-events-load]').each(function() {
            var calendarUrl = $(this).attr('data-calendar-url');
            var calendarTimezone = $(this).attr('data-calendar-timezone');

            var block = $('.events-wrapper', this);
            var limit = 6;

            $.ajax({
                url: calendarUrl,
                data: {
                    start: Math.floor(Date.now() / 1000),
                    limit: limit
                },
                dataType: 'json',
                success: function (events) {
                    var eventsClone = $('<div class="event"><div class="event-date"><div class="event-date"></div></div><div class="event-details"><h3 class="event-title"></h3><small class="event-time"></small></div></div>');

                    events.sort(function(x, y){
                        return  x.start_time - y.start_time;
                    });

                    $.each(events, function (index, event) {
                        // stop loop
                        if (index >= limit) {
                            return false;
                        }

                        var newClone = eventsClone.clone(true);
                        var mStart = moment.tz(parseInt(event.start_time) * 1000, calendarTimezone);
                        var mEnd = moment.tz(parseInt(event.end_time) * 1000, calendarTimezone);

                        newClone.find('.event-date').text(mStart.format('D MMMM'));

                        if (event.allDay) {
                            newClone.find('.event-time').text('all day event');
                        } else {
                            if (event.start_time == event.end_time) {
                                newClone.find('.event-time').text(mStart.format('h:mm a'));
                            } else {
                                newClone.find('.event-time').text(mStart.format('h:mm a') + ' - ' + mEnd.format('h:mm a'));
                            }
                        }

                        newClone.find('.event-title').text(event.title);
                        block.append(newClone);

                        newClone.click(function () {
                            var modal = newClone.data('modal');
                            if (!modal) {
                                modal = _self.createEventModal(event).appendTo($('body'), calendarTimezone);
                                newClone.data('modal', modal);
                            }

                            setTimeout(function () {
                                modal.addClass('active')
                            }, 100);
                        });
                    });

                    $('.event-block', block).each(function () {
                        $(this).addClass('blocks-' + $(this).find('.event').length);
                        $(this).find('.event').wrapAll('<div class="events-block-inside"></div>');
                    });
                }
            })
            .fail(function () {
                block.html('<p class="error"><strong>Unknown error</strong></p>');
            })
            .always(function () {
                block.addClass('events-loaded');
            });
        })
    },

    // create modal from reach event
    createEventModal: function (event, calendarTimezone) {
        $modal = $('<div class="cal-modal"></div>');
        var $holder = $('<div class="content-holder"></div>')
        var $content = $('<div class="content"></div>');

        $content.append('<h2>' + event.title + '</h2>');

        if (typeof calendarTimezone == 'undefined') {
            calendarTimezone = event.timezone;
        }

        var mStart = moment.tz(parseInt(event.start_time) * 1000, calendarTimezone);
        var mEnd = moment.tz(parseInt(event.end_time) * 1000, calendarTimezone);

        if (mStart.isSame(mEnd,'day')) {
            if (event.allDay) {
                $content.append('<small>'+mStart.format('D MMMM')+' (All Day)</small>');
            } else {
                $content.append('<small>'+mStart.format('D MMMM')+' (' + mStart.format('h:mma') + ' - ' + mEnd.format('h:mma') + ')</small>');
            }
        } else{
            $content.append('<small>' + mStart.format('D MMM') + ' - ' + mEnd.format('D MMM') + '</small>');
        }
        $content.append('<p>' + event.body + '</p>');

        if (event.attachments && event.attachments.length) {
            $.each(event.attachments, function (i, attachment) {
                switch (attachment.type) {
                    case 'address':
                        $content.append('<div class="attachment attachment-address"><i class="fa fa-map-marker"></i> ' + String(attachment.address).replace("\n", '<br>') + '</div>');
                        break;
                    case 'contact':
                        var contact_details = [];
                        if (attachment.contact_name) {
                            contact_details.push(attachment.contact_name);
                        }
                        if (attachment.contact_phone) {
                            contact_details.push($('<a>').attr('href', 'tel:' + attachment.contact_phone ).text(attachment.contact_phone ).prop('outerHTML'));
                        }
                        if (attachment.contact_email) {
                            contact_details.push($('<a>').attr('href', 'mailto:' + attachment.contact_email ).text(attachment.contact_email ).prop('outerHTML'));
                        }
                        $content.append('<div class="attachment attachment-contact"><i class="fa fa-phone"></i> ' + contact_details.join('<br>') + '</div>');
                        break;
                    case 'link':
                        $content.append('<div class="attachment attachment-link"><i class="fa fa-link"></i> ' + $('<a target="blank">').attr('href', attachment.url).text(attachment.url).prop('outerHTML')  + '</div>');
                        break;
                    case 'file':
                        $content.append('<div class="attachment attachment-file"><i class="fa fa-file"></i> ' + $('<a target="blank">').attr('href', attachment.url).text(attachment.file_name).prop('outerHTML') + '</a></div>');
                        break;
                }
            });
        }

        $modal.click(function (event) {
            if ($(event.target).hasClass("cal-modal") || $(event.target).hasClass("close") || $(event.target).hasClass("content-holder")) {
                $(this).removeClass('active');
            }
        });

        $holder.append('<div class="close">CLOSE</div>');
        $holder.append($content);
        $modal.append($holder);

        return $modal;
    },

    forms: function () {
        // Send google analytics event on form submission
        $('[data-form-name] form').submit(function () {
            var formWrapper = $(this).closest('[data-form-name]');
            if (window.ga) {
                ga('send', 'event', formWrapper.attr('data-form-name'), formWrapper.attr('data-form-page'));
            }
        });
    },

    entryCalculator: function(){
        /* =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= */
        // Entry year calculator

        var today = new Date();
        var current_year = today.getFullYear();
        var birth_year = current_year - 10;

        // for (var i = 0; i < 19; i++) {
        //     $('.calc-year').append('<option value="'+birth_year+'">'+birth_year+'</option>');
        //     birth_year++;
        // }

        $('.entry-calculator-btn').click(function() {
            if ($('.calc-month').val() != '' && $('.calc-year').val() != '') {
                $('.entry-year-table').show();
                $('.entry-year-table .entry-table').html('');
                $('.close-entry-calculator').show();
                var mon = $('.calc-month').val();
                var y = parseInt($('.calc-year').val());
                if (mon == 'January' || mon == 'February' || mon == 'March' || mon == 'April' || mon == 'May' || mon == 'June') {
                    y = y + 5;
                } else {
                    y = y + 6;
                }
                if (y >= current_year) {
                    $('.entry-year-table .entry-table').append('<label>Prep</label><input value='+y+'></input>');
                }
                y++;
                for (var i = 1; i < 8; i++) {
                    if (y >= current_year) {
                        $('.entry-year-table .entry-table').append('<label>Year '+ i + '</label><input value='+y+'></input>');
                    }
                    y++;
                }
                $(".entry-year-table input").attr("disabled","disabled");
            }
        });
        $('.close-entry-calculator').click(function() {
            $('.entry-year-table').hide();
            $(this).hide();
            $('.calc-year').val('');
        });
    },

    popups: function() {
        $('.action-modal').each(function() {
            var modal = $(this)
            var key = 'modal-' + modal.data('key')
            var cookie = Cookies.get(key)

            if (!cookie) {
                modal.addClass('active')
                $('#wrapper').addClass('action-modal-active')

                var image = modal.find('img')
                var imageHeight = image.outerHeight()
                $('#wrapper').css('paddingTop', imageHeight)
                image.on('load', function() {
                    var imageHeight = this.outerHeight()
                    $('#wrapper').css('paddingTop', imageHeight)
                })
                $(window).on('resize', function() {
                    var imageHeight = image.outerHeight()
                    $('#wrapper').css('paddingTop', imageHeight)
                })

                modal.find('.close-action-modal').click(function() {
                    modal.addClass('delete')
                    modal.removeClass('active')
                    $('#wrapper').removeClass('action-modal-active')
                    Cookies.set(key, 'viewed', { expires: 5 })
                })
                modal.find('.action-modal-background').click(function() {
                    modal.removeClass('active')
                })
            }
        });
    },

    analytics: function () {
        // Track clicks on external links
        $('body').on('click', 'a[href]', function (e) {
            var domain = String(window.location.host).replace(/^www\./, '');
            var openInNewWindow = $(this).attr('target') == '_blank';
            var url = $(this).attr('href');

            // Find the domain of the link. Works with http, https and protocol-less urls
            var linkAnatomy = url.match(/^(https?:)?\/\/(www\.)?([^\/\s]+)/);
            if (linkAnatomy) {
                var linkDomain = linkAnatomy[3];

                // Check if google analytics is loaded and the url is external
                if (window.ga && domain != linkDomain) {
                    ga('send', 'event', 'Navigation', 'Open URL', url);

                    // If the link will open in this window we should delay navigation until the event is sent
                    if (!openInNewWindow && !e.isDefaultPrevented()) {
                        e.preventDefault();

                        // Push the navigation onto the queue (will be processed after event is sent)
                        ga(function () {
                            // Navigate to url
                            window.location.href = url;
                        })

                        return false;
                    }
                }
            }
        });
    },
    employment: function() {
        $('.application-form').each(function(i,e) {
            var $form = $(e);
            var jobTitle = $form.data('job-title');
            $form.find('input[id$="-fields-applyingFor"]').val(jobTitle);
        });
    },
    newsletters: function(){


        $('.newsletter-sidebar-desktop').theiaStickySidebar({
            minWidth: 1024,
            additionalMarginTop: 50
        });

        $('.newsletter-events .events-wrapper').each(function() {
            var articles_wrapper = $(this);
            if ($(articles_wrapper).find('div').length == 0) {
                $(".newsletter-events-header").hide();
            }
        })

        $('.newsletter-archive-wrap .show-newsletter-archive').click(function() {
            $(this).hide();
            $('.newsletter-archive-wrap .newsletter-archive-reach').show();
        });

        //Newsletter section

        $('.newsletter-article-expandable').css({ 'max-height': '320px' })

        $('.newsletter-article').find('.newsletter-article-expand').click(function() {

            var $article = $(this).parent()
            var $expandable = $article.find('.newsletter-article-expandable')
            var $content = $article.find('.newsletter-article-content')

            // toggle class
            $article.toggleClass('is-active')

            // set height to article size
            var height = $content.outerHeight() + 20;
            $expandable.css({ 'max-height': height + 'px' })

            if ($article.hasClass('is-active')) {
                // allow any height after animation done
                setTimeout(function() {
                    if ($article.hasClass('is-active')) {
                        $expandable.css({ 'max-height': 'none' })
                    }
                }, 300)
            } else {
                    // if collapsing article set max height
                    setTimeout(function() {
                    if (!$article.hasClass('is-active')) {
                        $expandable.css({ 'max-height': '320px' })
                    }
                }, 100)
            }

        });


        $('.newsletter-expand-all').click(function() {
            var $articles    = $('.newsletter-article');
            var $expandables = $('.newsletter-article-expandable');

            if ($(this).hasClass('is-expanded')) {
                $articles.removeClass('is-active');
                $expandables.css({'max-height': '320px'});
            } else {
                $articles.addClass('is-active');
                $expandables.css({'max-height': 'none'});
            }

            $(this).toggleClass('is-expanded');
        });

        $('.newsletter-toggle').click(function() {
            $(this).find('.toggle-nav-newsletter').toggleClass("cross");
            $(".newsletter-sidebar").toggleClass("open-sidenav");
        });

        $(".article-title, .article-sub-title").click(function() {
            var target = $($(this).attr('data-attr'));
            $('html, body').animate({
                    scrollTop: (target.offset().top) - 200
            }, 800);
            var window_width = $(window).width();
            if (window_width < 1023) {
                $(".toggle-nav-newsletter").toggleClass("cross");
                $(".newsletter-sidebar").toggleClass("open-sidenav");
            }
        });

        var window_width = $(window).width();
        if (window_width > 1023) {
            if ($(".toggle-nav-newsletter").hasClass('cross')){
                $(".toggle-nav-newsletter").removeClass('cross');
            }
            if ($(".newsletter-sidebar").hasClass('open-sidenav')){
                $(".newsletter-sidebar").removeClass('open-sidenav')
            }
        }
    },

}

// Yo!
$(document).ready(function () {
    digistorm.init();
});

jQuery(document).ready(function($) {
	var scrollBar = getScrollBarWidth();
	$('html').addClass("hidden-c");
	document.body.addEventListener('touchstart', function() {});
	wowo(jQuery);
	burger(jQuery);
	search(jQuery);
	richtext(jQuery);
	secondMenu(jQuery);
	toparrow(jQuery);
	quicklink_widget(jQuery);
	// parallax(jQuery);
	setTimeout(function(){
		slickArrow(jQuery);
	},20);
	bigSlick(jQuery);
	threeBlocks(jQuery);
	// readmore(jQuery);

	jQuery(window).scroll(function() {
		wowo(jQuery);
		// stickyMenu(jQuery);
		// parallax(jQuery);
	});

	jQuery(window).on("load", function() {
		wowo(jQuery);
	})

	jQuery(window).resize(function() {
		slickArrow(jQuery);
		bigSlick(jQuery);
		threeBlocks(jQuery);
	});
});

// function readmore($){
// 	$(".readmore,.read-more,.events-read-more,.blocks-c ul li a,.breadcrumbs ul li a").each(function(){
// 		var me = $(this),
// 		text = me.text();
// 		me.append("<span class='inner-text'>"+ text +"</span>");
// 	})
// }

function threeBlocks($){
	if($(".three-blocks").length>0){
		$(".three-blocks .item-c").each(function(){
			$(this).find(".text-c").css("height",$(this).find(".text").outerHeight(true));
		})
	}
}

function bigSlick($){
	if ($('.banner.big .text').length > 0) {
		var top = $(".banner.big .slick-c.slick-current .text").offset().top,
		height = $(".banner.big .slick-c.slick-current .text").outerHeight(true),
		bottom = top + height - 30 + 24;
		$(".banner.big").find(".slick-dots").css("top",bottom);
		$('.banner.big').on('afterChange', function(event, slick, currentSlide){
			setTimeout(function(){
				var top = $(".banner.big .slick-c.slick-current .text").offset().top,
				height = $(".banner.big .slick-c.slick-current .text").outerHeight(true),
				bottom = top + height + 24;
				$(".banner.big").find(".slick-dots").css("top",bottom);
			},401);
		});
	}
}

// function parallax($) {
// 	if ($(".hero").length > 0) {
// 		$(".hero").each(function(){
// 			var sh = $(window).scrollTop();
// 			var parallax_h = $(this).offset().top;
// 			var parallax_y = (parallax_h - sh) / 5;
// 			$(this).find(".img-c").css('transform','translate(-50% , calc(' +  parallax_y + 'px - 50%)');
// 		})
// 	}
// }

//init
function secondMenu($){
	if($("nav").length>0){
		$("nav .has-sub-second").append("<i class='iconfont icon-arrow-right'></i>");
		$("nav .has-sub-second").on("click", function() {
			if ($(window).width() < 1280) {
				var me = $(this);
				if (!me.hasClass("show")) {
					$(this).children(".sub-menu").slideDown();
					me.addClass("show").siblings(".has-sub-second").removeClass("show").children(".sub-menu").slideUp(250);
				} else {
					me.removeClass("show").children(".sub-menu").slideUp(250);
				}
			} else {
			}
		});
	}
}

function richtext($){
	if ($("a.has-desc").length > 0) {

		$("a.has-desc").click(function(e) {
			e.preventDefault();
			var me = $(this),
				parent = me.parents().parent(".item-c");

			if (!parent.hasClass("is-active")) {
				parent.find(".desc").stop().slideDown(250);
				parent.addClass("is-active").siblings("").removeClass("is-active").find(".desc").slideUp(250);
			} else {
				parent.removeClass("is-active").find(".desc").slideUp(250);
			}
		});
	}



    if ($(".accordion-c").length > 0) {

		$(".accordion-c .item-title").click(function(e) {
			e.preventDefault();
			var me = $(this),
				parent = me.parents(".item-c");
			if (!parent.hasClass("is-active")) {
				me.next().stop().slideDown(250);
				parent.addClass("is-active").siblings("").removeClass("is-active").find(".item-content").slideUp(250);
			} else {
				parent.removeClass("is-active").find(".item-content").slideUp(250);
			}
		});
	}

	if ($(".tabs-c").length > 0) {
		$(".tabs-c .tabs ul li").click(function(e) {
			e.preventDefault();
			var me = $(this),
				index = me.index(),
				parents = me.parents(".tabs-c"),
				content = parents.find(".text-c").eq(index);
			if (!me.hasClass("is-active")) {
				me.addClass("is-active").siblings(".is-active").removeClass("is-active");
				content.stop().fadeIn(1000).siblings().css("display", "none");
			}
		});
	}

	if ($('.banner .slick-track').length > 0) {
		/*$('.banner.big .slick').slick({
			dots: true,
			arrows: false,
			infinite: true,
			speed: 800,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			fade: true,
			autoplaySpeed: 8000,
			pauseOnHover: false,
			pauseOnFocus: false,
			draggable: false,
			prevArrow: '<button type="button" class="slick-prev iconfont icon-arrows-left2"></button>',
			nextArrow: '<button type="button" class="slick-next iconfont icon-arrow-right2"></button>',
		});*/
        if ($('.slick-current > .video-holder').length) {
            $('.slick-active .video-holder').closest('.banners').addClass('video-playing');
        }
		$('.banner.big .slick-track .slick-c').addClass('move');
		$('.banner.big .banners').on('afterChange', function(event, slick, currentSlide, nextSlide){
			$('.banner.big .slick-track .slick-c').removeClass('move');
			setTimeout(function(){
				$('.banner.big .slick-track .slick-c').addClass('move');
			},400);
            $('.banners').removeClass('video-playing');
            if ($('.slick-current > .video-holder').length) {
                $('.slick-active .video-holder').closest('.banners').addClass('video-playing');
            }
		});
	}

	if ($('.builder-box .slick').length > 0) {
		$('.builder-box .slick').slick({
			dots: true,
			arrows: true,
			infinite: true,
			speed: 800,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			fade: true,
			autoplaySpeed: 6000,
			pauseOnHover: false,
			pauseOnFocus: false,
			draggable: true,
			prevArrow: '<button type="button" class="slick-prev iconfont icon-arrows-left2"></button>',
			nextArrow: '<button type="button" class="slick-next iconfont icon-arrow-right2"></button>',
			responsive: [{
				breakpoint: 415,
				settings: {
					arrows: false,
				}
			}]
		});
	};

	if ($('.news .slick,.events .slick').length > 0) {
		$('.news .slick,.events .slick').slick({
			dots: false,
			arrows: true,
			infinite: true,
			speed: 800,
			slidesToShow: 3,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 6000,
			pauseOnHover: false,
			pauseOnFocus: false,
			draggable: false,
			prevArrow: '<button type="button" class="slick-prev iconfont icon-arrows-left"></button>',
			nextArrow: '<button type="button" class="slick-next iconfont icon-arrows-right"></button>',
			responsive: [{
				breakpoint: 1089,
				settings: {
					slidesToShow: 2,
				}
			},{
				breakpoint: 769,
				settings: {
					slidesToShow: 2,
					adaptiveHeight:true,
				}
			},{
				breakpoint: 601,
				settings: {
					slidesToShow: 1,
				}
			}]
		});
	}

	if ($('.links-comments .slick').length > 0) {
		$('.links-comments .slick').slick({
			dots: true,
			arrows: true,
			infinite: true,
			speed: 800,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 6000,
			pauseOnHover: false,
			pauseOnFocus: false,
			draggable: false,
			prevArrow: '<button type="button" class="slick-prev iconfont icon-arrows-left2"></button>',
			nextArrow: '<button type="button" class="slick-next iconfont icon-arrow-right2"></button>',
			responsive: [{
				breakpoint: 769,
				settings: {
					draggable: true,
				}
			}]
		});
	}
}

function slickArrow($){
	if ($('.links-comments .slick').length > 0) {
		var width = $(".links-comments .slick .slick-dots").width();
		$(".links-comments .slick .slick-prev").css("left","calc(50% - 36px - "+ width/2 + "px)");
		$(".links-comments .slick .slick-next").css("right","calc(50% - 36px - "+ width/2 + "px)");
	}
}
function toparrow($){
    $('.return-to-top a').click(function() {      // When arrow is clicked
        $('body,html').animate({
            scrollTop : 0                       // Scroll to top of body
        }, 500);
    });
}

function search($){
	if ($("nav #search-button").length > 0) {
		$('nav #search-button').click(function(e) {
			e.preventDefault();
			ot = $(window).scrollTop();
			$("#search-box").stop().fadeIn(300).addClass('show-it');
			sTime = setTimeout(function() {
				$("body").stop().addClass("modal-open-search");
				$("#search-box").find(".input").stop().focus();
			}, 900);
		});
		$('#search-close').click(function() {
			clearTimeout(sTime);
			$(".modal-open-search").removeClass("modal-open-search");
			$("html,body").stop().animate({
				scrollTop: ot
			}, 1);
			$("#search-box").stop().fadeOut(300).removeClass('show-it');
			$("#search-box").find(".input").stop().blur();
		});
	}
}

function burger($){
	$(".burger").on("click",function(){
		$(this).toggleClass("open");
		$(".nav").toggleClass("open");
	})
}

function stickyMenu($){
	var sh = $(window).scrollTop();
	if (sh > 100 && !$("nav").hasClass("smaller")) {
		$("nav").addClass("smaller");
	} else if (sh <= 100 && $("nav").hasClass("smaller")) {
		$("nav").removeClass("smaller");
	}
}

function getScrollBarWidth() {
	var oP = document.createElement('p'),
			styles = {
					width: '100px',
					height: '100px',
					overflowY: 'scroll'
			}, i, scrollbarWidth;
	for (i in styles) oP.style[i] = styles[i];
	document.body.appendChild(oP);
	scrollbarWidth = oP.offsetWidth - oP.clientWidth;
	oP.parentNode.removeChild(oP);
	return scrollbarWidth;
}

function quicklink_widget() {
    if ($(".portal-link").length > 0) {
        $(".portal-link a").click(function (e) {
            e.preventDefault();
            $('#quicklink-widget').toggleClass('is-active');
        });
        $("#quicklink-widget-close").click(function (e) {
            e.preventDefault();
            $('#quicklink-widget').removeClass("is-active");
        });
    }
}

function wowo($) {
	var wTop = $(window).scrollTop(),
		wHeight = $(window).height(),
		wBottom = wTop + wHeight;
	$(".wowo:not(.animated)").each(function() {
		var me = $(this),
			meTop = me.offset().top,
			meHeight = me.innerHeight(),
			meBottom = meTop + meHeight,
			limitTop = wTop - meHeight,
			limitBottom = wBottom + meHeight;
		if (meTop > limitTop && meBottom < limitBottom) {
			me.addClass("animated");
			setTimeout(function() {
				me.removeClass("animated wowo");
			}, 1500);
		}
	})
};
